import store from '../..';
import { stringyObject } from '../helpers';

export function setSearch(filters) {
  const search = {};
  if (
    filters
    && filters.searchType
    && filters.search
    && filters.search.toLowerCase
  ) {
    let type = filters.searchType;
    if (
      window.location.pathname.match(/screens/)
      && filters.searchType === 'Phone Number'
    ) {
      type = 'Screen Phone Number';
    }
    if (
      window.location.pathname.match(/keys/)
      && filters.searchType === 'Phone Number'
    ) {
      type = 'Keys Phone Number';
    }
    switch (type) {
      case 'Ad Schedule':
        search.ad_schedule = filters.search.toLowerCase();
        break;

      case 'Tablet':
      case 'Tablets':
      case 'Contact':
      case 'Stores':
      case 'Destinations':
        search.screen_id = filters.search.toLowerCase();
        break;

      case 'Screen Phone Number':
        search.phone_number = filters.search;
        break;

      case 'Keys Phone Number':
        search.phone = filters.search;
        break;

      case 'Phone Number':
      case 'Phone':
        search.contact = { phone: filters.search };
        break;

      case 'Course Name':
        if (filters.searchPage !== 'Screens') {
          search.group_name = filters.search.toLowerCase();
        }
        break;

      case 'Code':
        search.code = filters.search.toLowerCase();
        break;

      case 'City':
        search.address = { city: filters.search };
        break;

      case 'Email':
        search.email = filters.search.toLowerCase();
        break;

      case 'Name':
      case 'Group Name':
        if (filters.searchPage !== 'Screens') {
          search.group_name = filters.search.toLowerCase();
        }
        break;

      case 'Golf Cart ID':
        search.car_number = Number(filters.search);
        break;

      case 'Device ID':
        search.device_id = filters.search.toLowerCase();
        break;
      case 'Cart ID':
        break;

      default:
        throw new Error('Search type not found.');
    }
  }
  return search;
}
export function search() {
  const filters = store.getters['filters/getFilter'];
  return stringyObject(setSearch(filters));
}
